import { render, staticRenderFns } from "./LeftTabBarItem.vue?vue&type=template&id=cffaea6c&scoped=true&"
import script from "./LeftTabBarItem.vue?vue&type=script&lang=js&"
export * from "./LeftTabBarItem.vue?vue&type=script&lang=js&"
import style0 from "./LeftTabBarItem.vue?vue&type=style&index=0&id=cffaea6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffaea6c",
  null
  
)

export default component.exports